import { render, staticRenderFns } from "./admin_lxwm.vue?vue&type=template&id=7e2ffa7e&scoped=true"
import script from "./admin_lxwm.vue?vue&type=script&lang=js"
export * from "./admin_lxwm.vue?vue&type=script&lang=js"
import style0 from "./admin_lxwm.vue?vue&type=style&index=0&id=7e2ffa7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ffa7e",
  null
  
)

export default component.exports